<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/">
        <i class="fa fa-home"></i>
        Home
      </b-breadcrumb-item>
      <b-breadcrumb-item active>Settings</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="card">
      <div class="bg-dark card-header text-white">Settings</div>
      <div class="card-body">
        <div class="card">
          <div class="card-header">
            <ul class="card-header-tabs nav nav-tabs">
              <li class="nav-item">
                <a :class="currentSettingsTab === 'delegates' ? 'active' : null" class="nav-link">
                  Delegates
                </a>
              </li>
            </ul>
          </div>
          <div class="card-body">
            <UserDelegates />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import UserDelegates from "@/components/settings/UserDelegates.vue"

    export default {
        components: {
            UserDelegates
        },
        data() {
            return {
                currentSettingsTab: "delegates"
            }
        }
    }
</script>
